import React from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
  small?: boolean;
}

const OverlappingBackground = ({ className, small }: Props) => <div className={classNames('overlapping-background', className, { small })}>&nbsp;</div>;

export default OverlappingBackground;
